<section class="about-page">

  <div class="about-bg-orb about-bg-orb--1"></div>
  <div class="about-bg-orb about-bg-orb--2"></div>

  <div class="container">

    <!-- Section header -->
    <div class="about-header">
      <div class="about-eyebrow">
        <span class="about-eyebrow-rule"></span>
        <span class="about-eyebrow-text">{{ 'about.eyebrow' | translate }}</span>
        <span class="about-eyebrow-rule"></span>
      </div>
      <h1 class="about-title">{{ 'about.title1' | translate }} <em>{{ 'about.title2' | translate }}</em></h1>
    </div>

    <!-- Centered content -->
    <div class="about-content">

      <div class="about-accent-bar"></div>

      <p class="about-lead">{{ 'about.lead' | translate }}</p>

      <p class="about-body-text">{{ 'about.body' | translate }}</p>

      <!-- Stats row -->
      <div class="about-stats">
        <div class="about-stat">
          <strong>100k+</strong>
          <span>{{ 'about.stat1.label' | translate }}</span>
        </div>
        <div class="about-stat-sep"></div>
        <div class="about-stat">
          <strong>200+</strong>
          <span>{{ 'about.stat2.label' | translate }}</span>
        </div>
        <div class="about-stat-sep"></div>
        <div class="about-stat">
          <strong>100%</strong>
          <span>{{ 'about.stat3.label' | translate }}</span>
        </div>
      </div>

      <div class="about-divider">
        <span></span>
        <span class="about-diamond">✦</span>
        <span></span>
      </div>

      <div class="signature-block">
        <p class="signature-name">Radwa Khallaf</p>
        <span class="signature-title">{{ 'about.founder' | translate }}</span>
      </div>

    </div>

  </div>

</section>
